// src/routes/dispatcherRoutes.js
import AuthRoute from '../modules/Base/Auth/components/AuthRoute';
import Home from '../modules/Manager/index.jsx';
import ManagerDashboard from '../modules/Manager/ManagerDashboardPage/ManagerDashboardPage.js';
import RoutesProgress from '../modules/Manager/RoutesProgress/RoutesProgress.js';
import RouteProgressDetailsPage from '../modules/Manager/RouteProgressDetails/RouteProgressDetailsPage.jsx';
import FinStatistics from '../modules/Manager/FinStatistics/FinStatistics.js';
import FinStatistics2 from '../modules/Manager/FinStatisticV2/FinStatisticV2.jsx';
import ReportsPage from '../modules/Manager/ReportsPage/ReportsPage.js';


const dispatcherRoutes = [
  {path: '/manager',                          element: (<AuthRoute requiredPermissions={['pages:manager:view:any']}><Home /></AuthRoute>),},
  {path: '/manager/dashboard',                element: (<AuthRoute requiredPermissions={['pages:manager:view:any']}><ManagerDashboard /></AuthRoute>),},
  {path: '/manager/routesprogress',           element: (<AuthRoute requiredPermissions={['pages:manager:view:any']}><RoutesProgress /></AuthRoute>),},
  {path: '/manager/routesprogressdetails',    element: (<AuthRoute requiredPermissions={['pages:manager:view:any']}><RouteProgressDetailsPage /></AuthRoute>),},
  {path: '/manager/finstatistics',            element: (<AuthRoute requiredPermissions={['pages:manager:view:any']}><FinStatistics /></AuthRoute>),},
  {path: '/manager/finstatistics2',           element: (<AuthRoute requiredPermissions={['pages:manager:view:any']}><FinStatistics2 /></AuthRoute>),},
  {path: '/manager/report',                   element: (<AuthRoute requiredPermissions={['pages:manager:view:any']}><ReportsPage /></AuthRoute>),},

  
];

export default dispatcherRoutes;
